// This dictionary contains 54 untranslated or inherited localization strings.
// These strings are commented out. Uncomment and edit them if you want to add your translations.
import { surveyLocalization } from "survey-core";

export var catalanSurveyStrings = {
  pagePrevText: "Anterior",
  pageNextText: "Següent",
  completeText: "Complet",
  // previewText: "Preview",
  // editText: "Edit",
  // startSurveyText: "Start",
  otherItemText: "Un altre (descrigui)",
  // noneItemText: "None",
  // selectAllItemText: "Select All",
  progressText: "Pàgina {0} de {1}",
  // indexText: "{0} of {1}",
  // panelDynamicProgressText: "{0} of {1}",
  // questionsProgressText: "Answered {0}/{1} questions",
  emptySurvey: "No hi ha cap pàgina visible o pregunta a l'enquesta.",
  completingSurvey: "Gràcies per completar l'enquesta!",
  // completingSurveyBefore: "Our records show that you have already completed this survey.",
  loadingSurvey: "L'enquesta s'està carregant ...",
  placeholder: "Selecciona ...",
  // ratingOptionsCaption: "Tap to rate here...",
  // value: "value",
  requiredError: "Si us plau contesti la pregunta.",
  // requiredErrorInPanel: "Response required: answer at least one question.",
  requiredInAllRowsError: "Si us plau contesti les preguntes de cada filera.",
  numericError: "L'estimació ha de ser numèrica.",
  // minError: "The value should not be less than {0}",
  // maxError: "The value should not be greater than {0}",
  textMinLength: "Si us plau entre almenys {0} símbols.",
  textMaxLength: "Si us plau entre menys de {0} símbols.",
  textMinMaxLength: "Si us plau entre més de {0} i menys de {1} símbols.",
  minRowCountError: "Si us plau ompli almenys {0} fileres.",
  minSelectError: "Si us plau seleccioni almenys {0} variants.",
  maxSelectError: "Si us plau seleccioni no més de {0} variants.",
  numericMinMax: "El '{0}' deu ser igual o més de {1} i igual o menys de {2}",
  numericMin: "El '{0}' ha de ser igual o més de {1}",
  numericMax: "El '{0}' ha de ser igual o menys de {1}",
  invalidEmail: "Si us plau afegiu un correu electrònic vàlid.",
  // invalidExpression: "The expression: {0} should return 'true'.",
  urlRequestError: "La sol·licitud va tornar error '{0}'. {1}",
  urlGetChoicesError: "La sol·licitud va tornar buida de dates o la propietat 'trajectòria' no és correcta",
  exceedMaxSize: "La mida de l'arxiu no pot excedir {0}.",
  otherRequiredError: "Si us plau afegiu l'altra estimació.",
  uploadingFile: "El seu arxiu s'està pujant. Si us plau esperi uns segons i intenteu-ho de nou.",
  // loadingFile: "Loading...",
  // chooseFile: "Choose file(s)...",
  // noFileChosen: "No file chosen",
  // fileDragAreaPlaceholder: "Drop a file here or click the button below to load the file.",
  // confirmDelete: "Do you want to delete the record?",
  // keyDuplicationError: "This value should be unique.",
  // addColumn: "Add Column",
  addRow: "Afegiu una filera",
  removeRow: "Eliminar una filera",
  // emptyRowsText: "There are no rows.",
  // addPanel: "Add new",
  // removePanel: "Remove",
  // choices_Item: "item",
  matrix_column: "Columna",
  matrix_row: "Filera",
  // multipletext_itemname: "text",
  // savingData: "The results are being saved on the server...",
  // savingDataError: "An error occurred and we could not save the results.",
  // savingDataSuccess: "The results were saved successfully!",
  // saveAgainButton: "Try again",
  // timerMin: "min",
  // timerSec: "sec",
  // timerSpentAll: "You have spent {0} on this page and {1} in total.",
  // timerSpentPage: "You have spent {0} on this page.",
  // timerSpentSurvey: "You have spent {0} in total.",
  // timerLimitAll: "You have spent {0} of {1} on this page and {2} of {3} in total.",
  // timerLimitPage: "You have spent {0} of {1} on this page.",
  // timerLimitSurvey: "You have spent {0} of {1} in total.",
  // clearCaption: "Clear",
  // signaturePlaceHolder: "Sign here",
  // chooseFileCaption: "Choose file",
  // removeFileCaption: "Remove this file",
  // booleanCheckedLabel: "Yes",
  // booleanUncheckedLabel: "No",
  // confirmRemoveFile: "Are you sure that you want to remove this file: {0}?",
  // confirmRemoveAllFiles: "Are you sure that you want to remove all files?",
  // questionTitlePatternText: "Question Title",
  // modalCancelButtonText: "Cancel",
  // modalApplyButtonText: "Apply",
  // filterStringPlaceholder: "Type to search...",
  // emptyMessage: "No data to display",
  // noEntriesText: "There are no entries yet.\nClick the button below to add a new entry.",
  // more: "More"
};

surveyLocalization.locales["ca"] = catalanSurveyStrings;
surveyLocalization.localeNames["ca"] = "català";
